import React, { Component } from 'react';
import { Button, Spin, message } from 'antd';
import { getNamesByLanguage } from '../../constants';
import FooterButton from '../Components/FooterButton';
import AccountInfo from './Table/AccountInfo';
import ServiceCycle from './Table/ServiceCycle';
import Milestone from './Table/Milestone';
import PayType from './Components/PayType';

let names = {};
const Type = {
    serviceCycle: '按服务周期付款',
    milestone: '按里程碑付款',
};

class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serData: {name: '上海津石医药科技有限公司', deposit: '交通银行上海徐汇支行', account: '310066179018800006254'},
            loading: false,
            editable: false,
            type: 'serviceCycle',
        };
    }

    componentDidMount() {
        const { status, language } = this.props;
        let editable = false;
        if (status === 'add') {
            editable = true;
        }
        this.setState({ editable });
        names = getNamesByLanguage('payment', language);
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            this.props.changeStep(1);
        }
    }

    showPayType = () => {
        const { type } = this.state;
        this.payRef.show(type);
    }

    changeType = (type) => {
        this.setState({ type });
    }

    handleChange = data => {
        this.setState({ data });
    }

    toggleEditable = (editable) => {
        this.setState({ editable });
    }

    render() {
        const { status, height } = this.props;
        const { serData, loading, editable, type } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    <h2 className="quotation-title">{names.title}</h2>
                    { editable && <Button onClick={this.showPayType} style={{ margin: "0 10px 6px", background: '#62cf96', color: '#fff', borderColor: '#62cf96' }}>设置付款计划类型</Button> }
                    {
                        type === 'serviceCycle' ?
                            <ServiceCycle names={names} typeName={Type[type]} editable={editable} onChange={this.handleChange} />
                        :
                            <Milestone names={names} typeName={Type[type]} editable={editable} onChange={this.handleChange} />
                    }
                    <AccountInfo names={names} data={serData} />
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
                <PayType ref={el => this.payRef = el} changeType={this.changeType} />
            </Spin>
        );
    }
}

export default Payment;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Payment/index.js